import "@lottiefiles/lottie-player";
import { initCursor } from '../components/cursor.js';

import { setCookie, getCookie } from '../../../../../individual-restaurants/library/src/js/functions/cookies';

export const frontPageJs = () => {

	let areWeOnTheFrontPage = document.querySelector('#js__body.front-page');

	if(areWeOnTheFrontPage){

		//Do preloader
		let preloader = document.querySelector('#preloader')
		preloaderAnimation = document.querySelector("#preloader-animation");

		if(preloader && preloaderAnimation){
			if(getCookie('preloaderState') == 'loaded' ){
				preloader.remove();
				initCursor('.m__hero');
			}else{
				preloader.classList.add('playing');
				preloaderAnimation.addEventListener("complete", () => {
				  preloader.classList.add('animation-finished');
				  setCookie('preloaderState','loaded',1);
				  setTimeout(() => {
				  	initCursor('.m__hero');
				  },750);

				});
			}
		}

		

		//Then initialise the cursor

		

	}
	

}